module.exports = __webpack_public_path__ + "img/troy.70cc58fa.png";